(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6504],{

/***/ 35962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ LocationSearch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(80419);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(20979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__(35610);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/select/dist/index.esm.js
var select_dist_index_esm = __webpack_require__(57026);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io/IoMdPin.js
var IoMdPin = __webpack_require__(82247);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/downshift/dist/downshift.esm.js + 1 modules
var downshift_esm = __webpack_require__(92706);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoChevronForward.js
var IoChevronForward = __webpack_require__(18935);
// EXTERNAL MODULE: ./src/utils/urls.ts
var urls = __webpack_require__(996);
;// CONCATENATED MODULE: ./src/components/Common/HighlightedWord.tsx



var HighlightedWord = function(param) {
    var label = param.label, highlights = param.highlights;
    if (!highlights || !highlights.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: label
        });
    }
    var parts = (0,react.useMemo)(function() {
        var currentIndex = 0;
        var parts = [];
        highlights.forEach(function(highlight) {
            if (currentIndex < highlight.start) {
                parts.push({
                    text: label.substring(currentIndex, highlight.start),
                    highlighted: false
                });
            }
            parts.push({
                text: label.substring(highlight.start, highlight.end),
                highlighted: true
            });
            currentIndex = highlight.end;
        });
        if (label.length > currentIndex) {
            parts.push({
                text: label.substring(currentIndex),
                highlighted: false
            });
        }
        console.log(label, parts);
        return parts;
    }, [
        label,
        highlights
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: parts.map(function(part) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                cursor: "pointer",
                as: "span",
                bg: part.highlighted ? "yellow" : "none",
                children: part.text
            });
        })
    });
};

// EXTERNAL MODULE: ./node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(81354);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(8002);
;// CONCATENATED MODULE: ./src/utils/crypto.ts


function encrypt(text) {
    return crypto_js.AES.encrypt("".concat(constants/* API_HASH_PREFIX */.KG, "||").concat(text, "||").concat(constants/* API_HASH_SUFFIX */.hM), constants/* API_HASH_KEY */.Js).toString();
}
function decrypt(text) {
    return AES.decrypt(text, API_HASH_KEY);
}
function isValid(text) {
    try {
        var decrypted = decrypt(text).toString(enc.Utf8);
        return Boolean(decrypted && decrypted.startsWith("".concat(API_HASH_PREFIX, "||")) && decrypted.endsWith("||".concat(API_HASH_SUFFIX)));
    } catch (e) {
        return false;
    }
}

;// CONCATENATED MODULE: ./src/components/Common/LocationSearch.tsx















var LocationSearch = function(_param) {
    var value = _param.value, onInputChange = _param.onInputChange, onSubmit = _param.onSubmit, allowEmptySubmit = _param.allowEmptySubmit, submitPath = _param.submitPath, pathParams = _param.pathParams, props = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onInputChange",
        "onSubmit",
        "allowEmptySubmit",
        "submitPath",
        "pathParams"
    ]);
    var ref;
    var router = (0,next_router.useRouter)();
    var timeoutRef = (0,react.useRef)();
    var ref1 = (0,react.useState)(30), radius = ref1[0], setRadius = ref1[1];
    var ref2 = (0,react.useState)([]), items = ref2[0], setItems = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(null), data = ref4[0], setData = ref4[1];
    var ref5 = (0,react.useState)(null), lookupData = ref5[0], setLookupData = ref5[1];
    var toast = (0,index_esm/* useToast */.pm)();
    (0,react.useEffect)(function() {
        if (router.query.q) {
            setInputValue(router.query.q);
        }
    }, [
        (ref = router.query) === null || ref === void 0 ? void 0 : ref.q
    ]);
    var ref6 = (0,downshift_esm/* useCombobox */.Kb)({
        initialInputValue: router.query.q || "",
        onSelectedItemChange: function onSelectedItemChange(param) {
            var selectedItem = param.selectedItem;
            if (selectedItem) {
                doLookup(selectedItem);
            }
        },
        onInputValueChange: function onInputValueChange(param) {
            var inputValue = param.inputValue, selectedItem = param.selectedItem;
            if (inputValue && inputValue.length >= 2) {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = setTimeout(function() {
                    if ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.title) !== inputValue) {
                        fetchData(inputValue);
                    }
                }, 500);
            }
        },
        items: items,
        itemToString: function itemToString(item) {
            if (!item) return "";
            return item.title;
        }
    }), isOpen = ref6.isOpen, getMenuProps = ref6.getMenuProps, getInputProps = ref6.getInputProps, getComboboxProps = ref6.getComboboxProps, highlightedIndex = ref6.highlightedIndex, getItemProps = ref6.getItemProps, openMenu = ref6.openMenu, inputValue = ref6.inputValue, setInputValue = ref6.setInputValue, selectItem = ref6.selectItem, selectedItem = ref6.selectedItem;
    var fetchData = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(queryString) {
            var response, json;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return fetch("/api/geocode?query=".concat(queryString, "&key=").concat(encodeURIComponent(encrypt("".concat(Date.now())))));
                    case 3:
                        response = _ctx.sent;
                        _ctx.next = 6;
                        return response.json();
                    case 6:
                        json = _ctx.sent;
                        setLoading(false);
                        if (json) {
                            setData(json);
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(queryString) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var doLookup = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(selectedItem) {
            var response, json;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return fetch("/api/geocode?lookup=".concat(selectedItem.id, "&key=").concat(encodeURIComponent(encrypt("".concat(Date.now())))));
                    case 3:
                        response = _ctx.sent;
                        _ctx.next = 6;
                        return response.json();
                    case 6:
                        json = _ctx.sent;
                        setLoading(false);
                        if (json) {
                            setLookupData(json);
                        // onSubmitHandler(selectedItem, json);
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(selectedItem) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        setItems((data === null || data === void 0 ? void 0 : data.items) || []);
        if (inputValue.length <= 1) {
            setItems([]);
        }
    }, [
        data,
        inputValue
    ]);
    (0,react.useEffect)(function() {
        return function() {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    var onSubmitHandler = function(selectedItem, lookupData) {
        var newPath = "";
        if (lookupData && selectedItem) {
            newPath = (0,urls/* addParamsToPath */.b)(submitPath || router.asPath, (0,_object_spread/* default */.Z)({
                lat: "".concat(lookupData.position.lat.toFixed(3)),
                lng: "".concat(lookupData.position.lng.toFixed(3)),
                radius: "".concat(radius),
                q: selectedItem.title
            }, pathParams));
        } else {
            newPath = (0,urls/* addParamsToPath */.b)(submitPath || router.asPath, (0,_object_spread/* default */.Z)({}, pathParams));
        }
        router.push(newPath).then(function() {
            onSubmit && onSubmit();
        });
    };
    var isMenuOpen = isOpen && items.length > 0;
    var onChangeRadius = function(val) {
        setRadius(parseInt(val, 10));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "100%",
        flex: 1
    }, getComboboxProps()), {
        pos: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                width: "100%",
                minW: {
                    base: "100%",
                    md: "450px"
                },
                flexDirection: {
                    base: "column",
                    md: "row"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_dist_index_esm/* InputGroup */.BZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* InputLeftElement */.Z8, {
                                display: {
                                    base: "none",
                                    md: "flex"
                                },
                                h: "46px",
                                pointerEvents: "none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IoMdPin/* IoMdPin */.Q, {
                                    color: "gray.300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                                fontSize: {
                                    base: "sm",
                                    md: "md"
                                },
                                borderColor: "gray.400",
                                placeholder: "Stadt oder Ort suchen...",
                                borderRadius: "sm",
                                borderBottomRadius: isMenuOpen ? 0 : "sm",
                                borderRightRadius: 0,
                                borderRightWidth: {
                                    base: "1px",
                                    md: 0
                                },
                                h: "46px",
                                pl: {
                                    base: 3,
                                    md: 10
                                },
                                pr: {
                                    base: "90px",
                                    md: "160px"
                                },
                                onFocus: function(e) {
                                    openMenu();
                                    if (inputValue !== "") {
                                        e.target.select();
                                    }
                                }
                            }, getInputProps())),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_dist_index_esm/* InputRightElement */.xH, {
                                h: "46px",
                                width: {
                                    base: "90px",
                                    md: "160px"
                                },
                                children: [
                                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Flex */.kC, {
                                        alignItems: "center",
                                        justifyContent: "center",
                                        w: "40px",
                                        h: "40px",
                                        p: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                                            color: "primary"
                                        })
                                    }),
                                    !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                                        fontSize: {
                                            base: "xs",
                                            md: "sm"
                                        },
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                display: {
                                                    base: "none",
                                                    md: "block"
                                                },
                                                children: "Umkreis"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, {
                                                onChange: function(e) {
                                                    onChangeRadius(e.target.value);
                                                },
                                                value: "".concat(radius),
                                                size: {
                                                    base: "xs",
                                                    md: "sm"
                                                },
                                                ml: 1,
                                                name: "radius",
                                                borderColor: "transparent",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "10",
                                                        children: "10km"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "20",
                                                        children: "20km"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "30",
                                                        children: "30km"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "50",
                                                        children: "50km"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: "100",
                                                        children: "100km"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                        mt: {
                            base: 4,
                            md: 0
                        },
                        px: 6,
                        bg: "primary",
                        color: "white",
                        borderRadius: "sm",
                        borderLeftRadius: 0,
                        _hover: {
                            bg: "primaryDark"
                        },
                        _active: {
                            bg: "primaryDarker"
                        },
                        h: "46px",
                        onClick: function() {
                            if (selectedItem && lookupData) {
                                onSubmitHandler(selectedItem, lookupData);
                            } else if (allowEmptySubmit) {
                                onSubmitHandler(null, null);
                            } else {
                                // Toast
                                toast({
                                    title: "Ort fehlt",
                                    description: "Sie m\xfcssen einen Ort suchen und aus der Liste ausw\xe4hlen.",
                                    status: "error",
                                    duration: 6000,
                                    isClosable: true
                                });
                            }
                        },
                        children: "Suchen"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getMenuProps()), {
                pos: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                mt: "-1px",
                zIndex: 14,
                children: isMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                    bg: "#fff",
                    border: "1px solid",
                    borderColor: "gray.400",
                    borderTopColor: "gray.200",
                    borderBottomRadius: "sm",
                    boxShadow: "md",
                    children: items.map(function(item, index) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            cursor: "pointer"
                        }, getItemProps({
                            item: item,
                            index: index
                        })), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                fontWeight: "bold",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                as: "a",
                                py: 2,
                                color: "primaryDark",
                                borderBottomRadius: index === items.length - 1 ? "xl" : 0,
                                px: 4,
                                __css: {
                                    bg: highlightedIndex === index && "gray.100"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        mr: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedWord, {
                                            label: item.title,
                                            highlights: (ref = item.highlights) === null || ref === void 0 ? void 0 : ref.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                        as: IoChevronForward/* IoChevronForward */.m
                                    })
                                ]
                            })
                        }), index);
                    })
                })
            }))
        ]
    }));
};


/***/ }),

/***/ 97126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ filtersToQuery; },
/* harmony export */   "TX": function() { return /* binding */ queryToFilters; }
/* harmony export */ });
/* unused harmony exports fieldNameToQuery, queryToFieldName, operatorToQuery, queryToOperator */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var lodash_invert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63137);
/* harmony import */ var lodash_invert__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_invert__WEBPACK_IMPORTED_MODULE_0__);


var OPERATOR_QUERY_MAP = {
    "=": "EQ"
};
var OPERATOR_QUERY_MAP_INVERTED = lodash_invert__WEBPACK_IMPORTED_MODULE_0___default()(OPERATOR_QUERY_MAP);
var FIELD_QUERY_MAP = {
    category: "c",
    sub_categories: "sc"
};
var FIELD_QUERY_MAP_INVERTED = lodash_invert__WEBPACK_IMPORTED_MODULE_0___default()(FIELD_QUERY_MAP);
var fieldNameToQuery = function(fieldName) {
    return FIELD_QUERY_MAP[fieldName] || fieldName;
};
var queryToFieldName = function(queryFieldName) {
    return FIELD_QUERY_MAP_INVERTED[queryFieldName] || queryFieldName;
};
var operatorToQuery = function(operator) {
    return OPERATOR_QUERY_MAP[operator] || operator;
};
var queryToOperator = function(queryOperator) {
    return OPERATOR_QUERY_MAP_INVERTED[queryOperator] || queryOperator;
};
var filtersToQuery = function(filters) {
    var parts = [];
    filters.forEach(function(filterGroup) {
        var ref;
        (ref = filterGroup.conditions) === null || ref === void 0 ? void 0 : ref.forEach(function(condition) {
            parts.push("".concat(fieldNameToQuery(condition.field), ":").concat(operatorToQuery(condition.operator), ":").concat(condition.value));
        });
    });
    return parts.join("|");
};
var queryToFilters = function(query) {
    if (!query || query === "") return [];
    var filterGroups = [];
    var parts = query.split("|");
    parts.forEach(function(part) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(part.split(":"), 3), fieldName = ref[0], operator = ref[1], value = ref[2];
        filterGroups.push({
            conditions: [
                {
                    field: queryToFieldName(fieldName),
                    operator: queryToOperator(operator),
                    value: value
                }, 
            ]
        });
    });
    return filterGroups;
};


/***/ }),

/***/ 996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ addParamsToPath; }
/* harmony export */ });
/* unused harmony export removeParamsFromPath */
var PLACEHOLDER_URL = "https://www.placeholder.de";
var addParamsToPath = function(path, params) {
    var url = new URL("".concat(PLACEHOLDER_URL).concat(path));
    if (url) {
        for(var param in params){
            if (params[param] && params[param] !== "" && params[param] !== null) {
                url.searchParams.set(param, params[param]);
            } else {
                url.searchParams.delete(param);
            }
        }
        return url.toString().replace(PLACEHOLDER_URL, "");
    }
    return path;
};
var removeParamsFromPath = function(path, params, all) {
    var url = new URL("".concat(PLACEHOLDER_URL).concat(path));
    if (url) {
        url.searchParams.forEach(function(param) {
            if (all || params[param]) {
                url.searchParams.delete(param);
            }
        });
        return url.pathname;
    }
    return path;
};


/***/ }),

/***/ 42480:
/***/ (function() {

/* (ignored) */

/***/ })

}]);